module.exports = __webpack_public_path__ + "img/img-7.d3db35f4.webp";